"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.log = exports.LEVELS = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _FACES;

var LEVELS = {
  LOG: 'LOG',
  ERROR: 'ERROR'
};
exports.LEVELS = LEVELS;
var FACES = (_FACES = {}, (0, _defineProperty2["default"])(_FACES, LEVELS.LOG, '💩'), (0, _defineProperty2["default"])(_FACES, LEVELS.ERROR, '🤢'), _FACES);

var log = function log(text) {
  var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : LEVELS.LOG;
  var writeLog = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined === 'development';
  if (writeLog) // eslint-disable-next-line no-console
    console.log("%c TELEMETRY %c ".concat(FACES[level] || '', " ").concat(text), 'background: #42368E; color: white;', 'background: unset; color: unset;');
};

exports.log = log;
var _default = log;
exports["default"] = _default;